module.exports = __webpack_public_path__ + "images/kihnu/apple-icon-152x152.png";